import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    sidebarOpen:    typeof window !== 'undefined' ? window.innerWidth >= 768 : true,
    activeModule:  null,   // 'HEALTHCARE' | 'FACTORY' | 'BILLING'
    notifications: [],
  },
  reducers: {
    toggleSidebar(state) {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen(state, { payload }) {
      state.sidebarOpen = payload;
    },
    setActiveModule(state, { payload }) {
      state.activeModule = payload;
    },
    addNotification(state, { payload }) {
      state.notifications.unshift({ id: Date.now(), ...payload });
      if (state.notifications.length > 5) state.notifications.pop();
    },
    removeNotification(state, { payload }) {
      state.notifications = state.notifications.filter(n => n.id !== payload);
    },
  },
});

export const {
  toggleSidebar, setSidebarOpen,
  setActiveModule,
  addNotification, removeNotification,
} = uiSlice.actions;

export const selectSidebar     = (s) => s.ui.sidebarOpen;
export const selectActiveModule = (s) => s.ui.activeModule;
export const selectNotifications = (s) => s.ui.notifications;

export default uiSlice.reducer;
